import styled from 'styled-components';
import { SummaryText } from '../styles';

export const Separator = styled.hr`
  width: 80%;
  border: none;
  border-top: 1px solid #e8e9ea;
  margin: 0.3rem 0;
`;

export const QuestionTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  padding: 0.7vw;
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ff780c;
  border-radius: 15px;
  align-items: center;
  padding: 1rem;
  width: 100%;
  min-height: 200px;
  background-color: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.05);
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  gap: 0.6rem;
  padding: 0.4rem 0.5rem 0;
  align-items: center;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const Title = styled(SummaryText)`
  font-size: clamp(14px, 1.4vw, 20px);
  font-weight: 700;
  word-break: break-word;
  overflow-wrap: break-word;
  text-align: center;
  color: #ff780c;
`;

export const QuestionText = styled(SummaryText)`
  font-size: clamp(11px, 0.85vw, 13px);
  text-align: center;
  color: #555;
`;

export const FooterText = styled(SummaryText)`
  font-size: clamp(10px, 0.75vw, 12px);
  text-align: center;
  color: #999;
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 0.7rem;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 0.25rem 0;
  gap: 0.1rem;
`;

export const ValueText = styled(SummaryText)<{ $isNoAnswer?: boolean }>`
  font-size: ${({ $isNoAnswer }) =>
    $isNoAnswer ? 'clamp(14px, 1.4vw, 18px)' : 'clamp(28px, 2.8vw, 40px)'};
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
`;

export const LabelText = styled(SummaryText)`
  font-size: clamp(11px, 0.85vw, 13px);
  font-weight: 600;
  text-align: center;
  color: #555;
`;
